module.exports = __webpack_public_path__ + "media/assets/images/authors/nosco_team-02626a9fd64c0e13eac54d670979896f.jpg";